import React from "react";
import { ApproveInnovationAnnouce10DetailContainer } from "../../../containers/SupportSystem/SupportForm/ApproveInnovationAnnouce10DetailContainer";

export function ApproveInnovationAnnouce10DetailPage () {
    return(
        <ApproveInnovationAnnouce10DetailContainer/>
    )
}